import { z } from "zod";

/** Panel: kampanyalar (K-016). İndirim yalnızca Poji ücretinden; hizmet veren tam alır. */
const Minor = z.string().regex(/^\d{1,9}$/);
const Uuid = z.string().uuid();

export const PromotionBody = z
  .object({
    marketId: Uuid,
    name: z.string().trim().min(2).max(120),
    /** boş = kodsuz, koşul tutunca kendiliğinden uygulanır */
    code: z
      .string()
      .trim()
      .regex(/^[A-Za-z0-9_-]{3,32}$/)
      .nullable()
      .default(null),
    audience: z.enum(["all", "first_order"]),
    discountType: z.enum(["percent", "amount"]),
    /** percent: Poji ücretinin yüzdesi (bps, 5000 = %50) */
    valueBps: z.number().int().min(1).max(10000).nullable().default(null),
    /** amount: Poji ücretinden sabit indirim (kuruş) */
    valueMinor: Minor.nullable().default(null),
    /** percent için üst sınır (kuruş) */
    maxDiscountMinor: Minor.nullable().default(null),
    /** en az sipariş (tahmini hizmet bedeli, kuruş) */
    minOrderMinor: Minor.nullable().default(null),
    categoryId: Uuid.nullable().default(null),
    serviceId: Uuid.nullable().default(null),
    startsAt: z.string().datetime({ offset: true }).nullable().default(null),
    endsAt: z.string().datetime({ offset: true }).nullable().default(null),
    /** toplam kullanım sınırı */
    maxRedemptions: z.number().int().min(1).max(1_000_000).nullable().default(null),
    /** kişi başı kullanım (boş = sınırsız) */
    perUserLimit: z.number().int().min(1).max(100).nullable().default(null),
  })
  .superRefine((b, ctx) => {
    if (b.discountType === "percent" && b.valueBps === null)
      ctx.addIssue({ code: "custom", path: ["valueBps"], message: "required" });
    if (b.discountType === "amount" && b.valueMinor === null)
      ctx.addIssue({ code: "custom", path: ["valueMinor"], message: "required" });
    if (b.categoryId && b.serviceId)
      ctx.addIssue({ code: "custom", path: ["serviceId"], message: "category_or_service" });
    if (b.startsAt && b.endsAt && Date.parse(b.endsAt) <= Date.parse(b.startsAt))
      ctx.addIssue({ code: "custom", path: ["endsAt"], message: "before_start" });
  });
export type PromotionBody = z.infer<typeof PromotionBody>;

export interface AdminPromotion {
  id: string;
  marketId: string;
  marketCode: string;
  name: string;
  code: string | null;
  audience: "all" | "first_order" | "user_list";
  discountType: "percent" | "amount";
  valueBps: number | null;
  valueMinor: string | null;
  maxDiscountMinor: string | null;
  minOrderMinor: string | null;
  categoryId: string | null;
  serviceId: string | null;
  startsAt: string | null;
  endsAt: string | null;
  maxRedemptions: number | null;
  perUserLimit: number | null;
  isActive: boolean;
  state: "active" | "scheduled" | "ended" | "off";
  /** iptal/süresi dolmamış işlerde kullanım ve faturalanmış toplam indirim */
  redemptions: number;
  discountTotalMinor: string;
}
